import { render } from "./RequestPasswordResetForm.vue?vue&type=template&id=17c3a531"
import script from "./RequestPasswordResetForm.vue?vue&type=script&lang=js"
export * from "./RequestPasswordResetForm.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/gizmorilla.com/toolbox.gizmorilla.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__